import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Paper, Box, Typography, Slider, TextField, Button,
} from '@material-ui/core';
import '../TargetSearchComponent';
import {
  TARGET_SEARCH_DISP_ITEM,
  TRIAL_FLG,
} from '../../../../common/const';
import {
  setScoreSlider,
  setScoreFrom,
  setScoreTo,
  setCheckScoreFrom,
  setCheckScoreTo,
  setErrMsgScore,
  setClassificationList,
} from '../../../actions/TargetAction';
import styles from '../style.module.css';
import MyIcon from '../../common/MyIcon';

const CLASSIFICATION = {
  CAUTION_REQUIRED: 'F',
  CAUTION: 'E',
  LITTLE_CAUTION: 'D',
  NORMAL: 'C',
  GOOD: 'B',
  EXCELLENT: 'A',
};

const MARKS = [
  { value: 0, label: '0点' },
  { value: 10, label: '' },
  { value: 20, label: '' },
  { value: 30, label: '' },
  { value: 40, label: '' },
  { value: 50, label: '50点' },
  { value: 60, label: '' },
  { value: 70, label: '' },
  { value: 80, label: '' },
  { value: 90, label: '' },
  { value: 100, label: '100点' },
];

class EvaluationIndexParts extends Component {
  handleChange = (event, value) => {
    const {
      setScoreSliderAct,
    } = this.props;
    setScoreSliderAct(value);
  };

  handleChangeCommitted = (event, value) => {
    const {
      errMsgScore,
      setScoreFromAct,
      setScoreToAct,
      setErrMsgScoreAct,
      setCheckScoreFromAct,
      setCheckScoreToAct,
    } = this.props;

    if (errMsgScore) {
      // エラー内容初期化
      setErrMsgScoreAct();
      setCheckScoreFromAct(false);
      setCheckScoreToAct(false);
    }
    setScoreFromAct(String(value[0]));
    setScoreToAct(String(value[1]));
  };

  /**
   *格付けボタン押下
   */
  onClassification = (str) => {
    const { setClassificationListAct, classificationList } = this.props;

    // 選択した格付けを取得
    const selItem = str;
    // 格付けリスト編集用の変数を宣言
    let newClassification = [];

    if (classificationList.indexOf(str) === -1) {
      // 選択した格付けを上場市場リストに追加
      newClassification.push(selItem);
      // 他に選択済の格付けがある場合は格付けリストに追加
      if (classificationList && classificationList.length > 0) {
        newClassification = classificationList.concat(newClassification);
      }
    } else {
      // チェックOFFに変更した格付けの配列位置を取得
      const delIndex = classificationList.indexOf(selItem);
      // 格付けが取得できた場合、該当の格付けを削除
      if (delIndex >= 0) {
        newClassification = classificationList.concat(newClassification);
        newClassification.splice(delIndex, 1);
      }
    }
    setClassificationListAct(newClassification);
  };

  render() {
    const {
      scoreSlider,
      scoreFrom,
      scoreTo,
      setScoreFromAct,
      setScoreToAct,
      errMsgScore,
      checkErrFlg,
      classificationList,
      onBlurScore,
      targetingDispItems,
      userInfo,
    } = this.props;

    // 評点、格付けの表示・非表示設定
    let dispHyotenFlg = false;
    let dispKakudukeFlg = false;
    if (targetingDispItems) {
      targetingDispItems.search_option_list.forEach((label) => {
        if (label.item_name === TARGET_SEARCH_DISP_ITEM.HYOTEN) {
          dispHyotenFlg = true;
        }
        if (label.item_name === TARGET_SEARCH_DISP_ITEM.KAKUDUKE) {
          dispKakudukeFlg = true;
        }
      });
    }

    return (
      <Box className={`${styles.parts}`}>
        <Paper elevation={0} className={`${styles.sectionBox}`}>
          <Box className={`${styles.alignItemsCenter} ${styles.displayFlex} ${styles.marginBottomTitle}`}>
            <Box className={`${styles.sectionTitleIcon} ${styles.marginRightHalf}`} />
            <Typography variant="h6" component="div" className={`${styles.sectionTitle}`}>評価指標</Typography>
          </Box>
          <Box className={`${styles.searchTargetItemInterval}`}>
            {dispHyotenFlg && (
              <Box>
                <Box width={420}>
                  <Typography variant="subtitle1" component="div" className={`${styles.sectionSubTitle}`}>評点</Typography>
                  <Slider
                    className={`${styles.marginTopHalf} ${styles.marginLeft1} ${styles.scoreColor}`}
                    aria-labelledby="range-slider"
                    valueLabelDisplay="auto"
                    value={scoreSlider}
                    onChange={this.handleChange}
                    onChangeCommitted={this.handleChangeCommitted}
                    marks={MARKS}
                    disabled={userInfo.trial_flag === TRIAL_FLG.ON}
                  />
                </Box>
                <Box className={`${styles.displayFlex} ${styles.alignItemsFlexEnd}`}>
                  <TextField
                    variant="outlined"
                    value={scoreFrom || ''}
                    onChange={(ev) => setScoreFromAct(ev.target.value)}
                    onBlur={onBlurScore}
                    margin="normal"
                    error={checkErrFlg.checkScoreFrom}
                    InputProps={{
                      classes: {
                        input: userInfo.trial_flag === TRIAL_FLG.ON
                          ? styles.disabledText : styles.inputSizingMedium,
                      },
                    }}
                    placeholder="00"
                    disabled={userInfo.trial_flag === TRIAL_FLG.ON}
                  />
                  <Typography variant="body2" className={`${styles.marginLeftHalf} ${styles.marginBottomHalf}`}>点</Typography>
                  <Box className={`${styles.marginRight1} ${styles.marginLeft1} ${styles.marginBottom15}`}>
                    <Typography variant="body2">～</Typography>
                  </Box>
                  <TextField
                    variant="outlined"
                    value={scoreTo || ''}
                    onChange={(ev) => setScoreToAct(ev.target.value)}
                    onBlur={onBlurScore}
                    margin="normal"
                    error={checkErrFlg.checkScoreTo}
                    InputProps={{
                      classes: {
                        input: userInfo.trial_flag === TRIAL_FLG.ON
                          ? styles.disabledText : styles.inputSizingMedium,
                      },
                    }}
                    placeholder="00"
                    disabled={userInfo.trial_flag === TRIAL_FLG.ON}
                  />
                  <Typography variant="body2" className={`${styles.marginLeftHalf} ${styles.marginBottomHalf}`}>点</Typography>
                  <Box className={`${styles.errorMsgAreaMargin}`}>
                    <Typography variant="body2" className={`${styles.errorMsg}`} component="span">{errMsgScore}</Typography>
                  </Box>
                </Box>
              </Box>
            )}
            {dispKakudukeFlg && (
              <Box>
                <Typography variant="subtitle1" component="div" className={`${styles.sectionSubTitle}`}>格付け</Typography>
                <Box className={`${styles.classificationButtonInterval} ${styles.marginTopHalf}`}>
                  <Button
                    variant="contained"
                    startIcon={<MyIcon className={`${styles.faceIcon}`} type="faceIconF" />}
                    className={
                      `
                  classification 
                  ${classificationList
                        && classificationList.indexOf(CLASSIFICATION.CAUTION_REQUIRED) >= 0
                        ? styles.faceIconFCheckOn
                        : styles.faceIconFCheckOff}`
                    }
                    onClick={() => { this.onClassification(CLASSIFICATION.CAUTION_REQUIRED); }}
                  >
                    要警戒
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<MyIcon className={`${styles.faceIcon}`} type="faceIconE" />}
                    className={
                      `${styles.height2}
                  classification 
                  ${classificationList
                        && classificationList.indexOf(CLASSIFICATION.CAUTION) >= 0
                        ? styles.faceIconECheckOn
                        : styles.faceIconECheckOff}`
                    }
                    onClick={() => { this.onClassification(CLASSIFICATION.CAUTION); }}
                  >
                    注意
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<MyIcon className={`${styles.faceIcon}`} type="faceIconD" />}
                    className={
                      `${styles.height2}
                  classification 
                  ${classificationList
                        && classificationList.indexOf(CLASSIFICATION.LITTLE_CAUTION) >= 0
                        ? styles.faceIconDCheckOn
                        : styles.faceIconDCheckOff}`
                    }
                    onClick={() => { this.onClassification(CLASSIFICATION.LITTLE_CAUTION); }}
                  >
                    やや注意
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<MyIcon className={`${styles.faceIcon}`} type="faceIconC" />}
                    className={
                      `${styles.height2}
                  classification 
                  ${classificationList
                        && classificationList.indexOf(CLASSIFICATION.NORMAL) >= 0
                        ? styles.faceIconCCheckOn
                        : styles.faceIconCCheckOff}`
                    }
                    onClick={() => { this.onClassification(CLASSIFICATION.NORMAL); }}
                  >
                    通常
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<MyIcon className={`${styles.faceIcon}`} type="faceIconB" />}
                    className={
                      `${styles.height2}
                  classification 
                  ${classificationList
                        && classificationList.indexOf(CLASSIFICATION.GOOD) >= 0
                        ? styles.faceIconBCheckOn
                        : styles.faceIconBCheckOff}`
                    }
                    onClick={() => { this.onClassification(CLASSIFICATION.GOOD); }}
                  >
                    優良
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<MyIcon className={`${styles.faceIcon}`} type="faceIconA" />}
                    className={
                      `${styles.height2}
                  classification 
                  ${classificationList
                        && classificationList.indexOf(CLASSIFICATION.EXCELLENT) >= 0
                        ? styles.faceIconACheckOn
                        : styles.faceIconACheckOff}`
                    }
                    onClick={() => { this.onClassification(CLASSIFICATION.EXCELLENT); }}
                  >
                    非常に優良
                  </Button>
                </Box>
              </Box>
            )}
          </Box>
        </Paper>
      </Box>
    );
  }
}

export default connect(
  (state) => ({
    scoreSlider: state.target.scoreSlider,
    scoreFrom: state.target.scoreFrom,
    scoreTo: state.target.scoreTo,
    errMsgScore: state.target.errMsgScore,
    checkErrFlg: state.target.checkErrFlg,
    classificationList: state.target.classificationList,
    targetingDispItems: state.target.targetingDispItems,
    userInfo: state.common.userInfo,
  }),
  (dispatch) => ({
    setScoreSliderAct: (obj) => dispatch(setScoreSlider(obj)),
    setScoreFromAct: (str) => dispatch(setScoreFrom(str)),
    setScoreToAct: (str) => dispatch(setScoreTo(str)),
    setCheckScoreFromAct: (bool) => dispatch(setCheckScoreFrom(bool)),
    setCheckScoreToAct: (bool) => dispatch(setCheckScoreTo(bool)),
    setErrMsgScoreAct: (str) => dispatch(setErrMsgScore(str)),
    setClassificationListAct: (obj) => dispatch(setClassificationList(obj)),
  }),
)(EvaluationIndexParts);
